import { render, staticRenderFns } from "./album-item.vue?vue&type=template&id=7b3c830a&scoped=true&"
import script from "./album-item.vue?vue&type=script&lang=js&"
export * from "./album-item.vue?vue&type=script&lang=js&"
import style0 from "./album-item.vue?vue&type=style&index=0&id=7b3c830a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c830a",
  null
  
)

export default component.exports